import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getAllOffers = async (id, context = {}, { throwOnError = false } = {}) => {
  if (id === null) {
    return;
  }

  try {
    const getAllOffersFn = httpsCallable(functions, 'getAllOffersV2');
    const result = await getAllOffersFn({
      auctionId: id,
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });
    return result.data.data;
  } catch (error) {
    console.error('Error obteniendo ofertas:', error);
    notifyPermissionDenied(error);
    if (throwOnError) throw error;
    return [];
  }
};
